export enum ActivityStatus {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE',
  DELETED = 'DELETED'
}
